<template>
  <b-card>
    <template #header>
      Billable
      <!--<ProjectCategoryFilter v-model="categoryFilter" class="mb-0 ml-1"></ProjectCategoryFilter> -->
      <b-button v-if="!isTv" :variant="groupByWeek ? 'success' : 'secondary'" class="btn-sm"
        @click="groupByWeek = !groupByWeek;">Group by week</b-button>
    </template>
    <div v-if="spinners.contentIsLoading" class="text-center">
      <b-spinner type="grow" variant="primary" />
    </div>
    <div v-else class="chart-body">
      <apexchart width="100%" height="100%" type="line" :options="chartOptions" :series="weekLoad"></apexchart>
    </div>
  </b-card>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import VueApexCharts from 'vue-apexcharts';
import Services from '@/services';

export default {
  mounted() {
    this.getData();
  },
  props: {
  },
  data() {
    return {
      spinners: {
        contentIsLoading: true,
      },
      // chartStart: ,
      issues: [],
      project: [],
      categoryFilter: {},
      categories: [],
      groupByWeek: true,

      chartOptionsArea: {
        stroke: {
          width: 2,
        },
        tooltip: {
          enabled: true,
          shared: true,
        },
        chart: {
          // stacked: true,
          animations: {
            enabled: false,
          },
          zoom: {
            // type: 'x',
            enabled: false,
            // autoScaleYaxis: true
          },

          // toolbar: {
          //   autoSelected: 'zoom'
          // }
        },

        plotOptions: {
        },
        xaxis: {
          // type: 'datetime',
          type: 'category'
        },
        yaxis: {
          min: 0, max: 100
        },
      },
    };
  },
  components: {
    apexchart: VueApexCharts,
  },
  computed: {
    ...mapGetters('Auth', ['isTv']),
    chartOptions() {
      const opts = { ...this.chartOptionsArea };
      const curYLabel = moment().startOf(this.groupByWeek ? 'week' : 'month').format(this.groupByWeek ? 'WW' : 'MM');
      const curIdx = this.yLabels.find((e) => e === curYLabel) || 0;
      const curIdxPercent = curIdx / this.yLabels.length;
      const lStep = 100.0 / this.yLabels.length;
      const yCnt = this.years.length;
      const color = '#0392cf';
      const colors = ['#7bc043', '#fdf498', '#ee4035', '#f37736'].slice(0, yCnt - 1);
      opts.colors = [...colors.reverse(), '#0392cf'];
      opts.fill = {
        type: [...((new Array(yCnt - 1)).map(() => ('solid'))), 'gradient'],
        gradient: {
          colorStops: [
            { offset: 0, color, opacity: 100 },
            { offset: Math.max(0, 100 * curIdxPercent - 2 * lStep), color, opacity: 100 },
            { offset: Math.max(0, 100 * curIdxPercent - 0.1 * lStep), color, opacity: 0 },
            { offset: 100 * curIdxPercent, color, opacity: 0 },
          ]
        }
      };

      return opts;
    },
    chartStart() {
      return this.isTv
        ? moment().startOf('year').add(-1, 'years')
        : moment().startOf('year').add(-3, 'years');
    },
    ganttIssues() {
      const s = moment(this.chartStart);
      const ignoreProjectKeys = ['APP']; // ignore certain projects as time logged in them is logged by unpaid persons (their hourly rate is low), (Praktikanti piemēram)
      return this.issues
        .filter((i) => s.isBefore(i.date_started_at) && i.date_started_at.isBefore(moment()))
        .filter((i) => !ignoreProjectKeys.includes(i.project.key));
    },

    chartHeight() {
      return `${this.ganttIssues.length * 18 + 50}px`;
    },
    maxDate() { return moment.max(this.ganttIssues.map((e) => e.date_started_at)); },
    weeks() {
      const s = moment(this.chartStart);
      // do not show future
      const e = moment.min(moment(this.maxDate).startOf('week').add(1, 'weeks'), moment());
      const weeks = [];
      for (let m = s; m.isBefore(e); m.add(1, 'weeks')) {
        weeks.push([moment(m), moment(m).add(1, 'weeks')]); // console.log(m.format('YYYY-MM-DD'));
      }
      return weeks;
    },
    years() {
      const s = moment(this.chartStart);
      // do not show future
      const e = moment.min(moment(this.maxDate).startOf('year').add(1, 'year'), moment());
      // console.log(s.format(),e.format());
      const years = [];
      for (let m = s; m.isBefore(e); m.add(1, 'year')) {
        years.push([moment(m), moment(m).add(1, 'year')]); // console.log(m.format('YYYY-MM-DD'));
      }
      return years;
    },
    months() {
      const s = moment(this.chartStart);
      // do not show future
      const e = moment.min(moment(this.maxDate).startOf('month').add(1, 'month'), moment());
      const months = [];
      for (let m = s; m.isBefore(e); m.add(1, 'month')) {
        months.push([moment(m), moment(m).add(1, 'month')]); // console.log(m.format('YYYY-MM-DD'));
      }
      return months;
    },
    yLabels() { return Array.from(this.groupByWeek ? Array(52).keys() : Array(12).keys()).map((i) => String((i % 52) + 1).padStart(2, '0')); },
    weekLoad() {
      const unbillableCategoryIds = this.categories.filter((c) => ['Absences', 'INT', 'INT ', 'Pipeline'].includes(c.name)).map((c) => c.id);

      let result = this.ganttIssues;
      result = result.reduce((categories, i) => {
        if (unbillableCategoryIds.includes(i.project.category_id)) {
          // is unbillable
          categories[1].issues.push(i);
        } else {
          categories[0].issues.push(i);
        }
        return categories;
      }, [
        { name: 'Billable', issues: [] },
        { name: 'Other', issues: [] }
      ]);

      const groupBy = this.groupByWeek ? this.weeks : this.months;
      // const groupBy = this.months;

      const totalLoad = groupBy.map(([w, w2]) => {
        // const w2 = moment(w).add(7, 'days');
        const hoursLoadInWeek = this.ganttIssues.reduce((hours, i) => {
          return hours + (i.date_started_at.isAfter(w) && i.date_started_at.isBefore(w2) ? i.actuals_time : 0);
        }, 0);
        return {
          x: w.valueOf(),
          y: Math.round((hoursLoadInWeek / 40) * 10) / 10,
        };
      });

      const yLabels = this.yLabels;
      // console.log(this.years);
      const onlyBillableIssues = result.find((p) => p.name === 'Billable').issues;
      result = this.years.map(([y, y2]) => {
        const data = groupBy.filter(([w, w2]) => ((w.isSameOrAfter(y, 'year') || w2.isSameOrAfter(y, 'year')) && w.isBefore(y2)))
          .map(([w, w2]) => {
            // const w2 = moment(w).add(7, 'days');
            const hoursLoadInWeek = onlyBillableIssues.reduce((hours, i) => {
              if (
                (i.date_started_at.isAfter(w) && i.date_started_at.isBefore(w2))
                && (w.isSameOrAfter(y, 'year') && w.isBefore(y2))
              ) return hours + i.actuals_time;
              return hours;
            }, 0);
            const totlaLoadW = totalLoad.find((l) => l.x === w.valueOf());
            return {
              // x: w.valueOf(),
              // x: w.format("MM"),
              x: w.format(this.groupByWeek ? 'WW' : 'MM'),
              // x: `${w.format('DD.MM')}`,
              y: Math.round(100 * (
                Math.round((hoursLoadInWeek / 40) * 10) / 10 / ((totlaLoadW && totlaLoadW.y > 0) ? totlaLoadW.y : 1)
              )),
            };
          });// .filter(d => d.y > 0)
        // console.log(data)
        return {
          name: y.format('YYYY'),
          data: yLabels.map((l) => {
            const value = data.find((d) => d.x === l && d.y > 0);
            return {
              x: l,
              y: value ? value.y : 0,
            };
          })
        };
      });
      // console.log(result[0].data.map(a=>a.x))
      return result;
    },

  },
  watch: {
  },
  methods: {
    getData() {
      Services.dash.allProjectDayLogs({ from_date: this.chartStart.format('YYYY-MM-DD') }).then(({ data }) => {
        // console.log(data);
        this.categories = data.categories;
        this.categoryFilter = data.projects.reduce((cats, p) => { cats[p.category_id] = true; return cats; }, {});
        this.issues = data.actuals.map((i) => {
          return {
            ...i,
            project: data.projects.find((p) => p.external_id === i.external_id),
            date_started_at: moment(i.date_started_at),
            actuals_time: i.actuals_time / 3600
          };
        });

        // // this.project = data;
        // // this.project.issues = null;
        this.spinners.contentIsLoading = false;
      });
    }
  }
};
</script>

<style>
ul.tooltipgantt {
  list-style-type: none;
  padding: 1em;
  margin: 0;
}

.chart-body {
  height: 615px;
}
</style>
